import type { TableColumnMeta } from '../common/ColumnSelector';

/** Column catalogue for the Azure DPS export table, grouped by category. */
export const EXPORT_COLUMN_METADATA: TableColumnMeta[] = [
  { id: 'select', label: 'Select', category: 'Actions', alwaysVisible: true },
  { id: 'name', label: 'Device Name', category: 'Basic Info' },
  { id: 'registrationId', label: 'Registration ID', category: 'Attestation' },
  { id: 'registrationStatus', label: 'Status', category: 'Basic Info' },
  { id: 'tpm', label: 'TPM Info', category: 'Attestation' },
  { id: 'macAddress', label: 'MAC Address', category: 'Basic Info' },
  { id: 'createdAt', label: 'Created', category: 'Timestamps' },
  { id: 'verifiedAt', label: 'Verified', category: 'Timestamps' },
  { id: 'lastSeen', label: 'Last Seen', category: 'Timestamps' },
];

/** Everything, so the table opens on exactly the columns it always showed. */
export const EXPORT_DEFAULT_COLUMNS = EXPORT_COLUMN_METADATA.map((column) => column.id);
